//import {WriteSingle,ReadMultiple} from 'SumoDataAccess.js';
//import {SumoPredicateBuilder} from 'Core/SumoPredicateBuilder';
function VictimProfile(aId) {
    "use strict";
    this.__type = 'VictimProfile:www.veritracks.com';
    this.Id = aId?aId:-1;
    this.Version = 0;
    this.FirstName = '';
    this.LastName = '';
    this.AgentId = -1;
    this.RiskLevelId = -1;
    this.OrganizationId = -1;
    this.VictimUserId = -1;
    this.Email = '';
    this.SamaPhoneNumber = '';
    this.SecondaryEmail = '';
    this.PrimaryPhone = '';
    this.SecondaryPhone = '';
    this.OffenderId = -1;
    this.TimeZoneCode = '';
    this.ProximityCaution = -1;
    this.ProximityCautionExtId = -1;
    this.ProximityWarning = -1;
    this.ProximityWarningExtId = -1;
    this.ProximityDanger = -1;
    this.ProximityDangerExtId = -1;
    this.GothimInquiryExtId = -1;
    this.TransactionId = '';
    this.IsNewVictim = 0;
    this.IsStalkerMobile = 0;
}
VictimProfile.prototype = new DataObjectBaseClass();
VictimProfile.prototype.constructor = VictimProfile;
VictimProfile.prototype.Write = function(aOnSuccess,aOnError){
    var lBuilder = new SumoPredicateBuilder();
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    function enrolleeVictimWrite_OnSuccess(uParams,uData,uExtraData){
        if(uExtraData.Enrollee){
            var e = new Enrollee(); 
            e.setValues(uExtraData.Enrollee);
            e.TimeZoneCode = _this.TimeZoneCode
            e.ArchiveFlag = 'N';
            e.Save(function onEnrolleeSaveSuccess(aParam,aEnrollee){
                setDataItem(aEnrollee.Id, 'Enrollees', aEnrollee);
                AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id'); // this new line fixes ticket 980
                aOnSuccess(uParams,uData,uExtraData);
                console.log('enrolleeVictimWrite_OnSuccess',uParams,uData,aEnrollee);
            },failure);
        }else {
            aOnSuccess(uParams,uData,uExtraData);
            console.log('enrolleeVictimWrite_OnSuccess',uParams,uData);
        }
        
    }
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('TimeZoneCode', this.TimeZoneCode, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    var lTimezone = query(getDataItems('TimeZone'), lBuilder.RootExpression);
    for(var lKey in lTimezone) {
        if (lTimezone.hasOwnProperty(lKey)) {
            this.TimeZoneId = lTimezone[lKey].Id;
        }
    }
    var data= {}; 
    data["aVictim"] = this;
    var _this = this;
    Fetcher.Post('/Victims',data,enrolleeVictimWrite_OnSuccess,function(a,r){
        failure(a,r);
        aOnError();
    });
};
VictimProfile.prototype.Update = function(aOnSuccess,aOnError){
    var lBuilder = new SumoPredicateBuilder();
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    function enrolleeVictimWrite_OnSuccess(uParams,uData,uExtraData){
        if(uExtraData.Enrollee){
            setDataItem(uExtraData.Enrollee.Id, 'Enrollees', uExtraData.Enrollee);
            AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id'); // this new line fixes ticket 980
        }
        aOnSuccess(uParams,uData,uExtraData);
    }
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('TimeZoneCode', this.TimeZoneCode, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    var lTimezone = query(getDataItems('TimeZone'), lBuilder.RootExpression);
    for(var lKey in lTimezone) {
        if (lTimezone.hasOwnProperty(lKey)) {
            this.TimeZoneId = lTimezone[lKey].Id;
        }
    }
    var data= {}; 
    data["aVictim"] = this;
    Fetcher.Put('/Victims/'+this.Id,data,enrolleeVictimWrite_OnSuccess,function(a,r){
        failure(a,r);
        aOnError();
    });
};
VictimProfile.prototype.Read = function(aOnSuccess){
    // "use strict";
    var _this = this;
    if(this.Id == -1) throw 'no Id found in the VictimProfile instance ';
    var _OnSuccessFn = function (parameters,res,extraData){
        var  obj = Object.assign({},_this,res,{__type:_this.__type});
        _this.setValues(obj);
        aOnSuccess(parameters,res,extraData);
    };
    Fetcher.Get('/Victims/'+this.Id, _OnSuccessFn,function(a,r){
        console.log(a,r);
    });
};
VictimProfile.prototype.IsCurrentlyPaired = function(){
    var flag = veritracks.core.GetOriProperty(this.OrganizationId, StalkerController.sama_property);
    return this.IsStalkerMobile === 1 && flag; //&& this.SamaAssociateEnrolleeId > 0;
};
if (typeof exports !== 'undefined') {
    module.exports = VictimProfile;
}